export function normalizeRetellApiPath(path) {
  const value = String(path || '');
  if (value.startsWith('/voice/retell/')) {
    return value.replace('/voice/retell/', '/retell/');
  }
  return value;
}
